import type { OrganizationBilling } from './billing';

export type OrganizationPlatformAccessStatus = 'active' | 'inactive' | 'unknown';

const ACTIVE_PLATFORM_ACCESS_STATUSES = new Set(['trialing', 'active', 'past_due']);

export function hasActiveOrganizationPlatformAccess(
    billing: OrganizationBilling | null | undefined,
    now: Date = new Date()
): boolean {
    if (!billing) {
        return false;
    }

    if (typeof billing.hasActivePlatformAccess === 'boolean') {
        return billing.hasActivePlatformAccess;
    }

    if (!billing.subscriptionStatus || !ACTIVE_PLATFORM_ACCESS_STATUSES.has(billing.subscriptionStatus)) {
        return false;
    }

    if (!billing.currentPeriodStart || !billing.currentPeriodEnd) {
        return false;
    }

    const currentPeriodStart = Date.parse(billing.currentPeriodStart);
    const currentPeriodEnd = Date.parse(billing.currentPeriodEnd);

    if (Number.isNaN(currentPeriodStart) || Number.isNaN(currentPeriodEnd)) {
        return false;
    }

    const currentTime = now.getTime();

    return currentPeriodStart <= currentTime && currentPeriodEnd > currentTime;
}

export function resolveOrganizationPlatformAccessStatus(
    billing: OrganizationBilling | null | undefined
): OrganizationPlatformAccessStatus {
    if (!billing) {
        return 'unknown';
    }

    return hasActiveOrganizationPlatformAccess(billing) ? 'active' : 'inactive';
}
